module.exports = __webpack_public_path__ + "static/media/zombie.e473f5ea.mp3";